import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { FinskeTrafikkmeldinger } from "../../RouteDescription/FinskeTrafikkmeldinger";

export default function FinnishTrafficMessageListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse &&
      props.roadFeatureResponse.finnishTrafficMessages &&
      props.roadFeatureResponse.finnishTrafficMessages.length !== 0 &&
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Finske trafikkmeldinger (${props.roadFeatureResponse?.finnishTrafficMessages.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto"
        unmountOnExit 
        >
          <FinskeTrafikkmeldinger roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}